import { setInterval } from 'core-js/internals/schedulers-fix'

import './pillars.scss'

const selectors = {
  pillar: '[data-pillar]',
  pillarImage: '[data-pillar-image]',
}

const setActiveImage = (images, activeIndex) => images.forEach((image, index) => (image.style.display = index === activeIndex ? 'block' : 'none'))

const initPillars = () => {
  const pillars = document.querySelectorAll(selectors.pillar)

  pillars?.forEach((pillar) => {
    let interval = undefined
    let activeIndex = 0

    const images = pillar.querySelectorAll(selectors.pillarImage)

    pillar.addEventListener('mouseenter', () => {
      interval = setInterval(() => {
        setActiveImage(images, activeIndex)

        activeIndex = activeIndex + 1 > images.length - 1 ? 0 : activeIndex + 1
      }, 1000)
    })

    pillar.addEventListener('mouseleave', () => {
      clearInterval(interval)
    })

    setActiveImage(images, 0)
  })
}

document.addEventListener('DOMContentLoaded', async function () {
  initPillars()
})
